import { render, staticRenderFns } from "./ApproveMsKeg.vue?vue&type=template&id=4fbfe65f&scoped=true"
import script from "./ApproveMsKeg.vue?vue&type=script&lang=js"
export * from "./ApproveMsKeg.vue?vue&type=script&lang=js"
import style0 from "./ApproveMsKeg.vue?vue&type=style&index=0&id=4fbfe65f&prod&scoped=true&lang=scss"
import style1 from "./ApproveMsKeg.vue?vue&type=style&index=1&id=4fbfe65f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbfe65f",
  null
  
)

export default component.exports